import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import { useMemo, useState } from 'react';
import api from 'services/api';
import useAppStore from 'store/useAppStore';
import SimplePDFViewer from './SimplePDFViewer';
import ImageViewerDialog from './ImageViewerDialog';
import { produce } from 'immer';
import keyBy from 'lodash/keyBy';
import checkViewFileType from 'utils/handleViewFile';
import { Image, PictureAsPdf } from '@mui/icons-material';
import FilePreviewButton from './FilePreviewButton';
import { v4 as uuidv4 } from 'uuid';
const SelectedProject = ({ project, handleViewFile }) => {
  const showNotification = useAppStore((state) => state.showNotification);
  const setInitEditData = useAppStore((state) => state.setInitEditData);
  const setter = useAppStore((state) => state.setter);
  const [getTempKeyInfo, { isLoading }] =
    api.endpoints.getTempKeyInfo.useMutation();
  return (
    <>
      <List component="nav">
        {project.files.map((fileName) => {
          return (
            <ListItem key={`${project.project_id}:${fileName}`}>
              <ListItemIcon className="min-w-0 mr-2">
                {fileName.endsWith('.pdf') && <PictureAsPdf color="warning" />}
                {fileName.endsWith('.png') && <Image color="primary" />}
              </ListItemIcon>
              <ListItemText primary={fileName} />
              <FilePreviewButton
                projectId={project.project_id}
                fileName={fileName}
                handleViewFile={handleViewFile}
              />
            </ListItem>
          );
        })}
      </List>
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="success"
        loading={isLoading}
        onClick={() => {
          getTempKeyInfo({
            user_id: useAppStore.getState().user.id,
            comp_name: useAppStore.getState().user.company,
            project_id: project.project_id,
            edit_time: project.edit_time,
          })
            .unwrap()
            .then((data) => {
              setInitEditData(data);
              setter('selectedProject', (draft) => {
                draft.project_id = project.project_id;
                draft.project_name = project.project_name;
                draft.files = project.files;
                // api沒回ori_project_id

                if (data.full_script && data.full_script.length > 0) {
                  draft.full_script_id = data.full_script[0]['全局腳本編號'];
                } else {
                  draft.full_script_id = uuidv4();
                }
              });
            })
            .catch((error) => {
              showNotification(error.message || '發生錯誤', 'error');
            });
        }}
      >
        選擇此檔案編輯
      </Button>
    </>
  );
};
const TempProjectList = () => {
  const userid = useAppStore((state) => state.user.id);
  const comp_name = useAppStore((state) => state.user.company);
  const { currentData, isFetching, isError, refetch } =
    api.endpoints.getTempProjectList.useQuery({
      user_id: userid,
      comp_name,
    });
  const [selectedPreviewProjectId, setSelectedPreviewProjectId] = useState('');
  const handleChange = (event) => {
    setSelectedPreviewProjectId(event.target.value);
  };
  const [fileViewer, setFileViewer] = useState({
    open: false,
    file: null,
    type: '',
  });
  const projectKeyById = useMemo(() => {
    if (!currentData?.project_list) {
      return {};
    }
    return keyBy(currentData.project_list, 'project_id');
  }, [currentData?.project_list]);
  const handleViewFile = (blob) => {
    const type = blob.type;
    const checkType = checkViewFileType(type);
    if (checkType === false) {
      return;
    }
    setFileViewer({
      type: checkType,
      open: true,
      file: window.URL.createObjectURL(blob),
    });
  };
  if (!currentData && isFetching) {
    return <CircularProgress />;
  }
  if (isError) {
    return (
      <div className="p-2 flex flex-col items-center">
        取得資料發生錯誤 <Button onClick={refetch}>重試</Button>
      </div>
    );
  }
  return (
    <>
      {currentData.project_list.length === 0 ? (
        <div>尚無暫存專案</div>
      ) : (
        <>
          <FormControl fullWidth>
            <InputLabel>舊有專案列表</InputLabel>
            <Select
              value={selectedPreviewProjectId}
              label="舊有專案列表"
              onChange={handleChange}
            >
              {currentData.project_list.map(({ project_id, project_name }) => {
                return (
                  <MenuItem key={project_id} value={project_id}>
                    {project_name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {projectKeyById[selectedPreviewProjectId] && (
            <>
              <SelectedProject
                handleViewFile={handleViewFile}
                project={projectKeyById[selectedPreviewProjectId]}
                selectedPreviewProjectId={selectedPreviewProjectId}
              />
            </>
          )}
          <SimplePDFViewer
            open={fileViewer.type === 'pdf' && fileViewer.open}
            file={fileViewer.file}
            onClose={() =>
              setFileViewer(
                produce((draft) => {
                  draft.open = false;
                }),
              )
            }
          />
          <ImageViewerDialog
            open={fileViewer.type === 'image' && fileViewer.open}
            file={fileViewer.file}
            onClose={() =>
              setFileViewer(
                produce((draft) => {
                  draft.open = false;
                }),
              )
            }
          />
        </>
      )}
    </>
  );
};
export default TempProjectList;
